import { render, staticRenderFns } from "./orgConfigList.vue?vue&type=template&id=797ba38c"
import script from "./orgConfigList.vue?vue&type=script&lang=js"
export * from "./orgConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports